import { createSlice } from "@reduxjs/toolkit";

const nameSlice = createSlice({
  name: "Product",
  initialState: {
    productList: [
      {
        id: 1,
        icon: require("@/assets/product/Core_icon.png").default,
        title: "NVIDIA GH200 Grace Hopper™ Superchip",
        desc: "Delivering breakthrough acceleration of large-scale AI, model training, and inference and high-performance computing (HPC) applications",
        detail: require("@/assets/product/GH200.png").default,
      },
      {
        id: 2,
        icon: require("@/assets/product/Core_icon.png").default,
        title: "NVIDIA H100 & H200 Tensor Core GPUs",
        desc: "Delivering unprecedented acceleration to power the world’s most advanced AI, data analytics, and HPC workloads",
        detail: require("@/assets/product/H100&H200.png").default,
      },
      {
        id: 3,
        icon: require("@/assets/product/Core_icon.png").default,
        title: "NVIDIA A100 Tensor Core GPU",
        desc: "Enabling researchers and scientists to combine simulation, data analytics, and AI to drive scientific progress",
        detail: require("@/assets/product/A100.png").default,
      },
      {
        id: 4,
        icon: require("@/assets/product/Core_icon.png").default,
        title: "NVIDIA L40S GPU",
        desc: "Combining powerful AI compute with the best-in-class graphics and media acceleration to power the next generation of data center workloads",
        detail: require("@/assets/product/L40S.png").default,
      },
      {
        id: 5,
        icon: require("@/assets/product/Core_icon.png").default,
        title: "NVIDIA A40 GPU",
        desc: "Combining professional graphics with powerful compute and AI, to meet today’s design, creative, and scientific challenges",
        detail: require("@/assets/product/A40.png").default,
      },
      {
        id: 6,
        icon: require("@/assets/product/Core_icon.png").default,
        title: "NVIDIA A16 GPU",
        desc: "Enabling virtual desktops and workstations with the power and performance to tackle any project from anywhere",
        detail: require("@/assets/product/A16.png").default,
      },
      {
        id: 7,
        icon: require("@/assets/product/Core_icon.png").default,
        title: "AMD Instinct™ MI300X Accelerator",
        desc: "Delivering best-in-class memory capacity and memory bandwidth for powerful and efficient AI and HPC deployments",
        detail: require("@/assets/product/MI300X.png").default,
      },
    ],
  },
  reducers: {
    changeState(state, { payload }) {
      state.state = payload;
    },
  },
});
export const getters = (state) => {
  return state.Product;
};
export const { changeState } = nameSlice.actions;
export default nameSlice.reducer;
